module.exports = new __parcel__URL__("the-rutles.2c6dc1ce.jpg").toString();